export const SELF_LEARN_ROUTES = {
  LIST: "",
  DETAIL: "page2",
  PLAYLIST: "playlist",
  VIDEO_PLAYER: "video-player",
  LEARN_TAB_VIDEO_PLAYER: "videoplayback",
  SHORTS_PLAYER: "shorts-player",
  REVISE_TAB: "reviseTab",
  REVISE_VIDEOS_VIEW_ALL: "reviseVideosViewAll",
  BOOKMARKS: "bookmarks",
  MYBOOKMARKS: "my-bookmarks",
  LIKEDVIDEO: "liked-videos",
  HISTORY: "history",
  TESTING: "testing",
  NOBOOKMARK: "nobookmark",
  CHAPTERLIST: "chapterList",
  POPULARBOOKS: "popularBooks",
  TOPICSOLUTION: "topicsolution",
  SECTIONSOLUTION: "sectionSolution",
  CHAPTERDETAILS: "chapterDetails",
  DOCUMENTS: "documents",

  PRACTICE_ALL_CARDS: "practice-all-cards",

  PRACTICE_START: "practice/start",
  PRACTICE_ANALYSIS: "practice/analysis",
  PRACTICE_PYQ: "practice/pyq",
  PRACTICE_PYQ_CONGRATS: "practice/pyq-congrats",
  PRACTICE_INTERACTIVE_ALL: "practice/interactive-all",
  PRACTICE_INTERACTIVE_STORY: "practice/interactive-story",
  EXERCISEPAGE: "exercise-questions",
  /** Full-page exercise intro (same level as `exercise-questions`, not under chapter chrome). */
  EXERCISE_INTRO: "exercise-intro",
  EXERCISE: "exercise",
  EXERCISEREPORT: "report",
  TOPIC_SUMMARY_VIEW_ALL: "topicSummaryViewAll",
  MEMORY_PRACTICE: "memoryPractice",
  MEMORY_CARD_REPORT: "memoryCardReport",
  FLASHCARDS: "flashcards",
  REVISE_QUESTIONS: "reviseQuestions",
  REVISE_QUESTIONS_REPORT: "reviseQuestionsReport",
  MEMORY_CARD: "memoryCard",
  /** Card of the Day — bookmarked memory cards deck (same flow as native). */
  CARD_OF_THE_DAY: "card-of-the-day",
} as const;
